import React, { FC } from 'react';

import { ReactComponent as SuccessIcon } from "../../../assets/icons/toast-success.svg";
import { ReactComponent as ErrorIcon } from "../../../assets/icons/toast-error.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

import styles from "./toastPopup.module.scss";
import clsx from 'clsx';

interface IPopupOptions {
  isSuccess?: boolean;
  title?: string;
  toast?: any;
  t?: any;
  onClose?: () => void;
}

const ToastPopup: FC<IPopupOptions> = ({ isSuccess, toast, title, t, onClose }) => {
  const handleClick = () => {
    toast.dismiss(t.id);
    if(onClose) {
      onClose()
    }
  }
  return (
    <div className={styles.toast__wrapper}>
      {isSuccess ? (
        <SuccessIcon className={styles.icon} />
      ) : (
        <ErrorIcon className={styles.icon} />
      )}
      <span className={clsx(styles.title, isSuccess ? styles.title_success: styles.title_error)}>{title}</span>
      <CloseIcon
        onClick={handleClick}
        className={
          isSuccess ? styles.success__close_icon : styles.error__close_icon
        }
      />
    </div>
  )
};

export default ToastPopup;
